<template>
    <div class="new-subscriber new-subscriber-confirmation mt-2 mb-2 lightgray-content p-3">
        <!-- Partido del suplemento -->
        <div class="mb-3 text-uppercase h5 lightgray-content py-2">
            <strong class="mb-2 red">{{ $t('front.sga.dia_abonado.suplemento') }}:</strong>
            {{ evento.nombre }}
        </div>

        <div class="row">
            <div class="col-12 col-lg-5">
                <label class="mb-2">{{ $t('gracias.datos_personales') }}</label>
                <div class="d-flex align-items-center mb-1">
                    <div>
                        <i class="fa fa-user"></i> {{ comprador.nombre }} {{ comprador.apellidos }}
                    </div>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div>
                        <i class="fa fa-id-card"></i> {{ comprador.dni }}
                    </div>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div>
                        <i class="fa fa-envelope"></i> {{ comprador.email }}
                    </div>
                </div>
                <div class="d-flex align-items-center mb-1">
                    <div>
                        <i class="fa fa-phone"></i> {{ comprador.telefono }}
                    </div>
                </div>

                <!-- Localidad del abono con el que se accede -->
                <div class="d-flex align-items-center mb-1" v-if="resumen.asiento">
                    <div>
                        <i class="fa fa-ticket-alt"></i>
                        {{ resumen.asiento.zona }}
                        <span v-if="resumen.asiento.fila">
                            / {{ $t('general.fila') }}: {{ resumen.asiento.fila }}
                        </span>
                        <span v-if="resumen.asiento.asiento">
                            / {{ $t('general.butaca') }}: {{ resumen.asiento.asiento }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 text-md-right mt-3 mt-md-0 pr-0">
                <div class="d-block">
                    <label>{{ $t('front.sga.dia_abonado.suplemento') }}</label>
                    <div class="h3 price mt-0">
                        <span class="h4">{{ resumen.importe_sin_gastos | formatear_precio }}</span>
                    </div>
                </div>
                <div class="d-block" v-if="resumen.gastos_gestion > 0">
                    <label>{{ $t('front.sga.dia_abonado.gastos_gestion') }}</label>
                    <div class="mt-0">
                        {{ resumen.gastos_gestion | formatear_precio }}
                    </div>
                </div>
                <div class="d-block mt-2">
                    <label>{{ $t('front.sga.dia_abonado.total') }}</label>
                    <div class="h3 price mt-0">
                        <span class="h2">{{ resumen.importe_total | formatear_precio }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Resumen de la compra del suplemento (día del club).
     *
     * El backend ya devuelve el desglose en `resumen-venta` con
     * `tipo: "suplemento"`; este componente solo lo pinta. Antes el resumen
     * caía en la rama de abonos y no mostraba nada, porque el suplemento no
     * trae `abonados`.
     */
    export default {
        name: 'DatosSuplemento',

        props: {
            resumen: {
                required: true,
                type: Object,
            },
        },

        computed: {
            evento() {
                return this.resumen?.evento || {};
            },
            comprador() {
                return this.resumen?.datos_comprador || {};
            },
        },
    };
</script>
